export default {
  noticeApi: {
    mail: {
      findActive: '/api/notice/mail/findActive',
      save: '/api/notice/mail/save',
      sendMail: '/api/notice/mail/sendMail'
    },
    sms: {
      findList: '/api/notice/sms/findList',
      delConfig: '/api/notice/sms/delConfig',
      findActive: '/api/notice/sms/findActive',
      save: '/api/notice/sms/saveOrUpdate',
      changeStatus: '/api/notice/sms/changeStatus',
      findSMSTypes: '/api/notice/sms/findSMSTypes',
      testSend: '/api/notice/sms/testSend'
    },
  }

}